import { render, staticRenderFns } from "./AdmissionsMovie.vue?vue&type=template&id=0db7ad00"
import script from "./AdmissionsMovie.vue?vue&type=script&lang=js"
export * from "./AdmissionsMovie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db7ad00')) {
      api.createRecord('0db7ad00', component.options)
    } else {
      api.reload('0db7ad00', component.options)
    }
    module.hot.accept("./AdmissionsMovie.vue?vue&type=template&id=0db7ad00", function () {
      api.rerender('0db7ad00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsMovie.vue"
export default component.exports